<script>
import useVuelidate from '@vuelidate/core';
import {required, requiredIf} from '@vuelidate/validators';

/* COMPOSANTS */
import ParametrageCommissionRow from './ParametrageCommissionRow';
import AkInputMoney from '@components/v2/input/AkInputMoney';
import AkCalendar from '@components/v2/input/AkCalendar';

/* MIXINS */
import comptaCommissionTypeConst from '@mixins/const/comptaCommissionTypeConst';

export default {
  components: {
    ParametrageCommissionRow,
    AkCalendar,
    AkInputMoney,
  },
  mixins: [comptaCommissionTypeConst],
  props: {
    modelValue: {
      required: true,
    },
    inputDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    dateVisible: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup() {
    return {v$: useVuelidate()};
  },
  emits: ['update:modelValue'],
  data() {
    return {};
  },
  validations() {
    return {
      currentValue: {
        date: {required},

        // FRAIS DE MENAGE INTERLOCATIFS
        fraisDeMenageVoyageurType: {},
        fraisDeMenageVoyageurGav: {},
        fraisDeMenageVoyageurGas: {},

        // FRAIS D'ACCUEIL
        fraisAccueilType: {},
        fraisAccueilGav: {},
        fraisAccueilGas: {},

        // FRAIS DE BLANCHISSERIE
        fraisDeBlanchisserieType: {},
        fraisDeBlanchisserieGav: {},
        fraisDeBlanchisserieGas: {},

        // FRAIS D'ASSURANCE
        fraisAssuranceType: {},
        fraisAssuranceGav: {},
        fraisAssuranceGas: {},

        // FRAIS DE SERVICE
        fraisDeServiceGaType: {required},
        fraisDeServiceGaGav: {required},
        fraisDeServiceGaGas: {required},

        // ACHAT HOTE
        achatHoteType: {required: requiredIf(this.premium)},
        achatHoteGav: {required: requiredIf(this.premium)},
        achatHoteGas: {required: requiredIf(this.premium)},

        // DEEP CLEANING
        deepCleaningType: {required: requiredIf(this.premium)},
        deepCleaningGav: {required: requiredIf(this.premium)},
        deepCleaningGas: {required: requiredIf(this.premium)},

        // FRAIS D'OUVERTURE HIVERNAGE
        ouvertureHivernageType: {required: requiredIf(this.premium)},
        ouvertureHivernageGav: {required: requiredIf(this.premium)},
        ouvertureHivernageGas: {required: requiredIf(this.premium)},

        // FRAIS DE FERMETURE HIVERNAGE
        fermetureHivernageType: {required: requiredIf(this.premium)},
        fermetureHivernageGav: {required: requiredIf(this.premium)},
        fermetureHivernageGas: {required: requiredIf(this.premium)},

        // FORFAIT ANNULATION
        forfaitFraisAnnulationHoteType: {required},
        forfaitFraisAnnulationHoteGav: {required},
        forfaitFraisAnnulationHoteGas: {required},

        // FRAIS DE MAINTENANCE
        fraisDeMaintenanceType: {required},
        fraisDeMaintenanceGav: {required},
        fraisDeMaintenanceGas: {required},

        // TAUX DE FRAIS DE MAINTENANCE
        fraisDeMaintenanceTaux: {required: requiredIf(this.premium)},

        // FRAIS DE MENAGE DEPART HOTE
        fraisDeMenageHoteType: {required: requiredIf(this.premium)},
        fraisDeMenageHoteGav: {required: requiredIf(this.premium)},
        fraisDeMenageHoteGas: {required: requiredIf(this.premium)},

        // NUISANCE SONORE
        nuisanceSonoreType: {required},
        nuisanceSonoreGav: {required},
        nuisanceSonoreGas: {required},

        // FRAIS DE LANCEMENT
        fraisDeLancementType: {required},
        fraisDeLancementGav: {required},
        fraisDeLancementGas: {required},

        // FRAIS DE MAINTENANCE (ANCIEN) (historique : utilisé seulement à l'affichage)
        fraisDeMaintenanceOldType: {},
        fraisDeMaintenanceOldGav: {},
        fraisDeMaintenanceOldGas: {},

        // FRAIS DE VERIFICATION MENAGE HOTE (historique : utilisé seulement à l'affichage)
        forfaitVerificationMenageHoteType: {},
        forfaitVerificationMenageHoteGav: {},
        forfaitVerificationMenageHoteGas: {},
      },
    };
  },
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      },
    },
    premium() {
      return this.currentValue.offer == 'OFFER1';
    },
  },
  methods: {
    validateForm() {
      this.v$.$touch();
      console.log(this.v$.currentValue);
      return !this.v$.currentValue.$error;
    },
  },
};
</script>

<template>
  <div v-if="this.currentValue" class="flex flex-col gap-2">
    <AkCalendar
      v-if="dateVisible"
      v-model="currentValue.date"
      class-name="col-md-6"
      :label="$t('operation.date')"
      date-format="dd/mm/yy"
      selection-mode="single"
      :validator="v$.currentValue.date"
      :disabled="inputDisabled" />

    <!--FRAIS DE SERVICE-->

    <ParametrageCommissionRow
      v-model="currentValue"
      :inputDisabled="inputDisabled"
      :validator="v$"
      name="fraisDeServiceGa"
      label="Frais de service" />

    <!--ACHAT HOTE-->

    <ParametrageCommissionRow
      v-model="currentValue"
      :inputDisabled="inputDisabled"
      :validator="v$"
      name="achatHote"
      label="Achat Hote" />

    <!--DEEP CLEANING-->

    <ParametrageCommissionRow
      v-model="currentValue"
      :inputDisabled="inputDisabled"
      :validator="v$"
      name="deepCleaning"
      label="Deep cleaning" />

    <!--FRAIS D'OUVERTURE HIVERNAGE-->

    <ParametrageCommissionRow
      v-model="currentValue"
      :inputDisabled="inputDisabled"
      :validator="v$"
      name="ouvertureHivernage"
      label="Ouverture hivernage" />

    <!--FRAIS DE FERMETURE HIVERNAGE-->

    <ParametrageCommissionRow
      v-model="currentValue"
      :inputDisabled="inputDisabled"
      :validator="v$"
      name="fermetureHivernage"
      label="Fermeture hivernage" />

    <!--FORFAIT ANNULATION-->

    <ParametrageCommissionRow
      v-model="currentValue"
      :inputDisabled="inputDisabled"
      :validator="v$"
      name="forfaitFraisAnnulationHote"
      label="Forfait annulation" />

    <!--FRAIS DE MAINTENANCE-->

    <ParametrageCommissionRow
      v-model="currentValue"
      :inputDisabled="inputDisabled"
      :validator="v$"
      name="fraisDeMaintenance"
      label="Frais de maintenance" />

    <!--TAUX DE FRAIS DE MAINTENANCE-->

    <div class="flex" v-if="this.premium">
      <AkInputMoney
        v-model="currentValue.fraisDeMaintenanceTaux"
        :validator="v$.currentValue.fraisDeMaintenanceTaux"
        :label="this.$t('recapitulatif_facturation.frais_maintenance_taux')"
        :disabled="inputDisabled"
        class-name="col-md-4" />
    </div>

    <!--FRAIS DE MENAGE DEPART HOTE-->

    <ParametrageCommissionRow
      v-model="currentValue"
      :inputDisabled="inputDisabled"
      :validator="v$"
      name="fraisDeMenageHote"
      label="Frais de ménage départ hôte" />

    <!--NUISANCE SONORE-->

    <ParametrageCommissionRow
      v-model="currentValue"
      :inputDisabled="inputDisabled"
      :validator="v$"
      name="nuisanceSonore"
      label="Nuisances sonores" />

    <!--FRAIS DE LANCEMENT-->

    <ParametrageCommissionRow
      v-model="currentValue"
      :inputDisabled="inputDisabled"
      :validator="v$"
      name="fraisDeLancement"
      label="Frais de lancement" />

    <!--FRAIS DE MAINTENANCE (ANCIEN) (READ ONLY)-->

    <ParametrageCommissionRow
      v-if="this.inputDisabled && this.premium"
      v-model="currentValue"
      :inputDisabled="inputDisabled"
      :validator="v$"
      name="fraisDeMaintenanceOld"
      label="Frais de maintenance (ancien)" />

    <!--FRAIS DE VERIFICATION MENAGE HOTE (READ ONLY)-->

    <ParametrageCommissionRow
      v-if="this.inputDisabled && this.premium"
      v-model="currentValue"
      :inputDisabled="inputDisabled"
      :validator="v$"
      name="forfaitVerificationMenageHote"
      label="Forfait vérification ménage hôte" />

    <div v-if="this.premium && this.inputDisabled" class="font-inter text-md font-semibold mb-2">
      Ancien frais (ne plus tenir compte à partir de Février 2025)
    </div>

    <!--FRAIS DE MENAGE INTERLOCATIFS-->

    <ParametrageCommissionRow
      v-if="this.inputDisabled"
      v-model="currentValue"
      :inputDisabled="inputDisabled"
      :validator="v$"
      name="fraisDeMenageVoyageur"
      :label="this.premium ? 'Frais de ménage interlocatifs' : 'Frais de ménage voyageur'" />

    <!--FRAIS D'ACCUEIL-->

    <ParametrageCommissionRow
      v-model="currentValue"
      v-if="this.inputDisabled"
      :inputDisabled="inputDisabled"
      :validator="v$"
      name="fraisAccueil"
      label="Frais d'accueil" />

    <!--FRAIS DE BLANCHISSERIE-->

    <ParametrageCommissionRow
      v-if="this.inputDisabled"
      v-model="currentValue"
      :inputDisabled="inputDisabled"
      :validator="v$"
      name="fraisDeBlanchisserie"
      label="Frais de blanchisserie" />

    <!--FRAIS D'ASSRANCE-->

    <ParametrageCommissionRow
      v-model="currentValue"
      v-if="this.inputDisabled"
      :inputDisabled="inputDisabled"
      :validator="v$"
      name="fraisAssurance"
      label="Frais d'assurance" />
  </div>
</template>
